import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  HomeContainer,
  Main,
  InvestUs,
  CalculateCredit,
  CalculateCreditTitle,
  CalculateCreditContainer,
  CalculateCreditContainerForm,
  CalculateCreditContainerResults,
  CalculateCreditButton,
  CalculateCreditAdvices,
  OurServices,
  Benefits
} from './home.styles';
import useHandleNumber from 'src/hooks/useHandleNumber';
import useCalculateCredit from 'src/hooks/useCalculateCredit';

export default function Home() {
  const [benefits, setBenefits] = useState(false);
  const [differences, setDifferences] = useState(false);

  const moneyRequest = useHandleNumber({ type: 'range', name: 'moneyRequest' });
  const termInDays = useHandleNumber({ type: 'range', name: 'termInDays' });

  let creditConditions = {
    amountToFinance: useCalculateCredit(moneyRequest, termInDays).mnyRqust * 0.9,
    commisionByDisposition:
      (0.18 / 360) *
      (useCalculateCredit(moneyRequest, termInDays).mnyRqust * 0.9) *
      useCalculateCredit(moneyRequest, termInDays).trmInDys,
    amountReceive:
      useCalculateCredit(moneyRequest, termInDays).mnyRqust * 0.9 -
      (0.18 / 360) *
        (useCalculateCredit(moneyRequest, termInDays).mnyRqust * 0.9) *
        useCalculateCredit(moneyRequest, termInDays).trmInDys,
    amountToPay:
      useCalculateCredit(moneyRequest, termInDays).mnyRqust * 0.9 +
      ((useCalculateCredit(moneyRequest, termInDays).mnyRqust * 0.9 * 0.15) / 360) *
        useCalculateCredit(moneyRequest, termInDays).trmInDys,
    interest:
      ((useCalculateCredit(moneyRequest, termInDays).mnyRqust * 0.9 * 0.15) / 360) *
      useCalculateCredit(moneyRequest, termInDays).trmInDys
  };

  const showBenefits = () => setBenefits(!benefits);
  const showDifferences = () => setDifferences(!differences);

  return (
    <HomeContainer>
      <Main>
        <div>
          <h2>
            Solicita un <span>crédito</span>
          </h2>
          <p>
            Unimos empresas que necesitan dinero con personas que desean prestarles, todas las
            operaciones son en Pesos Mexicanos y los servicios prestados solo están disponibles en
            México.
          </p>
        </div>
        <figure>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/img_app_home_solicita_un_credito.png`}
            alt="Finsphera solicita crédito"
          />
        </figure>
      </Main>
      <InvestUs>
        <div>
          <div>
            <figure>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_app_home_fast.png`}
                alt="Finsphera icono rápidez"
              />
            </figure>
            <h3>Rápido</h3>
            <p>¡5 minutos! Es el tiempo que te tomará llenar tu solicitud de préstamo</p>
          </div>
          <div>
            <figure>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_app_home_comfortable.png`}
                alt="Finsphera icono comodidad"
              />
            </figure>
            <h3>Comódo</h3>
            <p>Puedes hacer el 100% del proceso desde la comodidad de tu computadora.</p>
          </div>
          <div>
            <figure>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_app_home_economic.png`}
                alt="Finsphera icono económico"
              />
            </figure>
            <h3>Económico</h3>
            <p>Pagas una tasa de interés más baja que las opciones de crédito tradicionales.</p>
          </div>
        </div>
        <p>
          *El monto máximo de fondeo dependerá del análisis de FinSphera, con base en el análisis de
          crédito realizado a la empresa solicitante del crédito. FinSphera se reserva el derecho de
          publicar cualquier solicitud o monto. CAT. El Costo Anual Total de financiamiento
          expresado en términos porcentuales anuales es del 27% más IVA, para fines informativos y
          de comparación, incorpora la totalidad de los costos y gastos.
        </p>
        <Link to="/solicitante/niveles-de-riesgo">Calificaciones de crédito</Link>
      </InvestUs>
      <CalculateCredit>
        <CalculateCreditTitle>
          <h2>Calcula tu crédito</h2>
          <p>Con crédito a corto plazo podrás solicitar un crédito desde 30 hasta 120 días.</p>
        </CalculateCreditTitle>
        <CalculateCreditContainer>
          <CalculateCreditContainerForm>
            <p>
              Tu nivel dependerá de la evaluación de tu empresa. Cada Nivel cuenta con una comisión
              por apertura y tasa de interés.
            </p>
            <div>
              <p>Tasa informativa anual</p>
              <p>15%</p>
            </div>
            <div>
              <p>Monto solicitado</p>
              <div>
                <input {...moneyRequest} placeholder="$" min={50000} max={6000000} step={1000} />
                <p>${new Intl.NumberFormat('ja-JP').format(moneyRequest.data)}</p>
              </div>
            </div>
            <div>
              <p>Elige un plazo</p>
              <div>
                <input {...termInDays} min={30} max={120} step={5} />
                <p>{termInDays.data ? `${termInDays.data} días` : '0 días'}</p>
              </div>
            </div>
            <div>
              <p>Aforo:</p>
              <p>10%</p>
            </div>
          </CalculateCreditContainerForm>
          <CalculateCreditContainerResults>
            <p>Aquí podrás ver con claridad las condiciones de tu crédito.</p>
            <div>
              <div>
                <h3>Descripción</h3>
                <h3>Porcentaje</h3>
                <h3>Cantidad</h3>
              </div>
              <div>
                <p>Monto en garantía Monto a depositar.</p>
                <p>
                  {creditConditions.amountToFinance
                    ? '$' + new Intl.NumberFormat('ja-JP').format(creditConditions.amountToFinance)
                    : ''}
                </p>
              </div>
              <div>
                <p>Monto a depositar menos comisiones.</p>
                <p>
                  {creditConditions.commisionByDisposition
                    ? '$' +
                      new Intl.NumberFormat('ja-JP').format(creditConditions.commisionByDisposition)
                    : ''}
                </p>
              </div>
              <div>
                <p>Monto restante por depositar realizando el pago.</p>
                <p>
                  {creditConditions.amountReceive
                    ? '$' + new Intl.NumberFormat('ja-JP').format(creditConditions.amountReceive)
                    : ''}
                </p>
              </div>
              <div>
                <p>Comisiones por apertura de crédito.</p>
                <p>
                  {creditConditions.amountToPay
                    ? '$' + new Intl.NumberFormat('ja-JP').format(creditConditions.amountToPay)
                    : ''}
                </p>
              </div>
              <div>
                <p>IVA de comisión por apertura Intereses ordinarios.</p>
              </div>
              <div>
                <p>IVA de intereses ordinarios</p>
                <p>
                  {creditConditions.amountToFinance
                    ? '$' + new Intl.NumberFormat('ja-JP').format(creditConditions.amountToFinance)
                    : ''}
                </p>
              </div>
              <div>
                <p>Costo anual total.</p>
                <p>
                  {creditConditions.interest
                    ? '$' + new Intl.NumberFormat('ja-JP').format(creditConditions.interest)
                    : ''}
                </p>
              </div>
              <div>
                <p>Tasa fija anual.</p>
                <p>
                  {creditConditions.interest
                    ? '$' + new Intl.NumberFormat('ja-JP').format(creditConditions.interest)
                    : ''}
                </p>
              </div>
              <div>
                <p>
                  CAT: (El Costo Anual Total de financiamiento expresado en términos porcentuales
                  anuales que, para fines informativos y de comparación, incorpora la totalidad de
                  los costos y gastos inherentes a los créditos).
                </p>
              </div>
            </div>
          </CalculateCreditContainerResults>
        </CalculateCreditContainer>
        <CalculateCreditButton>
          <Link to="/solicitante/iniciar-sesion">Solicita un crédito</Link>
        </CalculateCreditButton>
        <CalculateCreditAdvices>
          <li>
            *Este documento es para efectos informativos y no constituye obligación u ofrecimiento
            formal por parte de Comunidad FinSphera, S.A.P.I. de C.V., en el otorgamiento del
            crédito. Las condiciones de los préstamos estarán sujetas a cambios sin previo aviso.
            Vigencia de la oferta al 31 de Agosto de 2020.
          </li>
          <li>*Todos los montos están calculados en pesos mexicanos (MXN).</li>
          <li>*CAT: el Costo Anual Total es informativo y está sujeto a cambios.</li>
          <li>
            *Las empresas pueden realizar pagos anticipados por el monto total o parcial de su
            crédito sin generar un costo por prepago.
          </li>
          <li>*Comunidad FinSphera, S.A.P.I. de C.V. solamente opera en la República Mexicana.</li>
        </CalculateCreditAdvices>
      </CalculateCredit>
      <OurServices>
        <div>
          <h2>
            Crédito de hasta <span>$12,000,000 M.N. *</span>
          </h2>
          <p>EN 2 SENCILLOS PASOS</p>
          <p>Entra, date de alta y en 48 horas te damos respuesta.</p>
          <Link to="/solicitante/inversion-solicitud-de-credito">Conoce los requisitos</Link>
          <p>
            *El monto máximo de fondeo dependerá de la autorización de Finsphera, con base en el
            análisis de crédito realizado a la empresa solicitante del crédito. Finsphera se reserva
            el derecho de publicar cualquier solicitud o monto. CAT. El Costo Anual Total del
            Financiamiento expresado en términos porcentuales anuales es del 27% más IVA, para ﬁnes
            informativos y de comparación e incorpora la totalidad de los costos y gastos.
          </p>
        </div>
        <figure>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/img_app_home_credit_up_to_12m.png`}
            alt="FinSphera nuestros servicios"
          />
        </figure>
      </OurServices>
      <Benefits showBenefits={benefits} showDifferences={differences}>
        <div>
          <div>
            <h3>Conoce los beneficios</h3>
            <figure onClick={showBenefits}>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/flechaCarrousel.png`}
                alt="flecha arriba"
              />
            </figure>
          </div>
          <div>
            <ul>
              <li>Sin cargos sorpresa.</li>
              <li>Pide solo el dinero que necesitas.</li>
              <li>Sin acudir a sucursales.</li>
              <li>Sin filas ni trámites complicados.</li>
              <li>Proceso 100% en linea, ágil y seguro.</li>
              <li>Tasa de interés del 17% y anual más una comisión mensual del 1%</li>
            </ul>
          </div>
        </div>
        <div>
          <div>
            <h3>¿Qué nos hace diferentes?</h3>
            <figure onClick={showDifferences}>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/flechaCarrousel.png`}
                alt="flecha arriba"
              />
            </figure>
          </div>
          <div>
            <ul>
              <li>Respuesta en menos de 48 horas.</li>
              <li>Agilidad en nuestros procesos de aprobación.</li>
              <li>Más incluyentes y flexibles que la banca tradicional.</li>
              <li>Disponibilidad 24/7 los 365 días del año.</li>
              <li>Transacciones seguras.</li>
            </ul>
          </div>
        </div>
      </Benefits>
    </HomeContainer>
  );
}
